var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9628",
    "data-name": "Trac\\xE9 9628",
    d: "M71.5,10a5,5,0,1,1,5-5A5,5,0,0,1,71.5,10Zm6.25,10H65.25A1.25,1.25,0,0,1,64,18.75a7.5,7.5,0,1,1,15,0A1.25,1.25,0,0,1,77.75,20Z",
    transform: "translate(-64)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfil);
export default __webpack_public_path__ + "static/media/iconProfil.c907e743c521051ccba2a5d32cdee464.svg";
export { ForwardRef as ReactComponent };